<div class="stats-grid" [style.--stats-columns]="columns">
  <div class="stat-card" *ngFor="let card of cards; trackBy: trackByTitle">
    <div class="stat-header">
      <span class="stat-title">{{ card.title }}</span>
    </div>

    <div class="stat-value">{{ card.value }}</div>

    <div class="stat-footer" *ngIf="card.change || card.subtitle">
      <span class="stat-change" [ngClass]="getChangeClass(card.changeType)">
        <ng-container *ngIf="card.changeType === 'positive' || card.changeType === 'negative'">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
        </ng-container>
        {{ card.change }}
      </span>

      <span class="stat-subtitle" *ngIf="card.subtitle">{{ card.subtitle }}</span>
    </div>
  </div>
</div>

